export default "/public/dist/img/logoinps.jpg";